import React from "react";
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const ResourceCard = (props) => {
  return (
    <Card raised id={props.idResource} sx={{ mb: 4, minWidth: 300 }}>
      <CardContent>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item>
            <Typography>
              <strong>Nome:</strong> {props.name}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <strong>PCD:</strong> {props.accessible === "0" ? "Não" : "Sim"}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ResourceCard.defaultProps = {
  list: false,
  idResource: undefined,
  name: undefined,
  accessible: undefined,
};

ResourceCard.propTypes = {
  list: PropTypes.bool,
  idResource: PropTypes.string,
  name: PropTypes.string,
  accessible: PropTypes.string,
};

export default ResourceCard;
